import { socialApiClient } from '@/shared/api-client/social-api-client';

export async function UpdateCampaignCreatorLabel(
  campaignId: string,
  creatorId: string,
  label: string | null,
  signal?: AbortSignal,
): Promise<void> {
  await socialApiClient.patch(`campaigns/${campaignId}/creators/${creatorId}/label`, {
    json: {
      label,
    },
    signal,
  });
}
